import { Component, OnInit, inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { QuoteModel } from '@app/pages/quotes/models/quote-model';
import { SharedModule } from "../../../../module/shared.module";
import { EImageType } from '@shared/pipes/image.pipe';

@Component({
  selector: 'beh-share-quote-presenter',
  imports: [SharedModule],
  templateUrl: './share-quote-dialog.component.html',
  styleUrl: './share-quote-dialog.component.scss'
})
export class ShareQuoteDialogComponent implements OnInit {
  data = inject<QuoteModel>(MAT_DIALOG_DATA);

  imageType = EImageType
  firstAuthor!: string;
  firstTranslator!: string;

  get inverseMediaRatio(): number {
    const parts = (this.data.mediaRatio || '').split(':');
    if (parts.length !== 2) return 1;

    const width = +parts[0];
    const height = +parts[1];
    if (!width || !height) return 1;

    return height / width;
  }

  ngOnInit(): void {
    this.firstAuthor = this.data?.book?.authors?.find(a => a.type === 'Author')?.name!;
    this.firstTranslator = this.data?.book?.authors?.find(a => a.type === 'Translator')?.name!;
  }
}
